import React from 'react';
import _get from 'lodash/get';
import { Theme } from '@material-ui/core/styles';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

function BasicInfoClassicSimple() {
  const classes = useStyles();

  const options = ['Name', 'Profile Photo', 'Job Title', 'Team'];

  return (
    <div className={classes.root}>
      <Typography variant="h6">Basic Info</Typography>
      <div>
        {options.map((option, i) => (
          <div className={classes.item} key={`classic-simple-basic-info-option-${i}`}>
            <FormControlLabel
              control={<Switch size="small" className={classes.switchMargin} checked disabled />}
              label={<Typography variant="body2">{option}</Typography>}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(3),
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    height: 41,
    marginLeft: theme.spacing(1.375),
  },
  switchMargin: {
    marginRight: theme.spacing(2.25),
  },
}));

export default BasicInfoClassicSimple;
